<template>
  <div class="card has-margin-bottom-lg">
    <header class="card-header">
      <h2 class="card-header-title is-primary">
        <span v-html="resultItemTitle" />
      </h2>
    </header>
    <div class="card-content" v-html="resultItemDesc" />
    <footer class="card-footer">
      <router-link :to="{ name: 'article', params: { product: data.product.slug, article: data.slug } }"
        class="card-footer-item" v-t="'read_more'" />
    </footer>
  </div>
</template>

<script>
export default {
  name: 'SearchItem',
  props: {
    data: { type: Object, required: true },
    term: { type: String }
  },
  methods: {
    highlightTerm (context) {
      let regex = new RegExp('(' + this.term + ')', 'ig')
      let result = context.replace(regex, '<mark>$1</mark>')

      return result
    }
  },
  computed: {
    resultItemTitle () {
      return this.highlightTerm(this.data.title)
    },
    resultItemDesc () {
      return this.highlightTerm(this.data.description)
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "read_more": "Read more"
  },
  "pt-BR": {
    "read_more": "Leia mais"
  }
}
</i18n>
